import React from 'react';

export default (props: { className?: string }) => {
  return <hr className={`border-ev-grey-3 my-4 ${props.className}`} />;
};
